export const modifiersTranslations = {
  ar: {
    title: 'إدارة المعدلات',
    addNew: 'إضافة معدل جديد',
    name: 'الاسم',
    nameEn: 'الاسم (إنجليزي)',
    type: 'النوع',
    typeSingle: 'اختيار واحد',
    typeMultiple: 'متعدد الخيارات',
    typeFreeText: 'نص حر',
    isRequired: 'مطلوب',
    options: 'الخيارات',
    optionName: 'اسم الخيار',
    optionNameEn: 'اسم الخيار (إنجليزي)',
    priceChange: 'تغيير السعر',
    addOption: 'إضافة الخيار',
    optionsCount: 'عدد الخيارات',
  },
  en: {
    title: 'Modifiers Management',
    addNew: 'Add New Modifier',
    name: 'Name',
    nameEn: 'Name (English)',
    type: 'Type',
    typeSingle: 'Single Choice',
    typeMultiple: 'Multiple Choices',
    typeFreeText: 'Free Text',
    isRequired: 'Required',
    options: 'Options',
    optionName: 'Option Name',
    optionNameEn: 'Option Name (English)',
    priceChange: 'Price Change',
    addOption: 'Add Option',
    optionsCount: 'Options Count',
  },
  fr: {
    title: 'Gestion des Modificateurs',
    addNew: 'Ajouter un Modificateur',
    name: 'Nom',
    nameEn: 'Nom (Anglais)',
    type: 'Type',
    typeSingle: 'Choix Unique',
    typeMultiple: 'Choix Multiples',
    typeFreeText: 'Texte Libre',
    isRequired: 'Obligatoire',
    options: 'Options',
    optionName: 'Nom de l\'Option',
    optionNameEn: 'Nom de l\'Option (Anglais)',
    priceChange: 'Changement de Prix',
    addOption: 'Ajouter une Option',
    optionsCount: 'Nombre d\'Options',
  },
}
